import React, { Component } from 'react';
import {LoginType} from '../../utils/status';
import {validateSettingAccessibility} from '../../utils/common';
import {Loader} from '../../components/Loader';

import {
    Link, Redirect
} from 'react-router-dom';
import {connect} from 'react-redux';
import {logout} from '../../actions/Logout'

class Information extends Component {
    constructor(props){
        super(props);

        let {loginType, data} = this.props
        this.state = {
            isSettingAccessible: loginType === LoginType.Account && validateSettingAccessibility(data)
        }
    }

    dispatchLogoutProcess = () => {
        this.props.dispatch({type: "USER_LOGOUT"});
        this.props.dispatch({type: "RESET_QUEUE"});
        localStorage.removeItem("persist:root");
		window.OneSignal?.deleteTag("orderTag");
    }

    handleLogout = () => {
		this.props.dispatch(logout(this.props.token, this.props.data.refresh_token))
    };

    componentWillReceiveProps(nextProps) {
		if (nextProps.loggedout) {
			return this.dispatchLogoutProcess()
		}
	}
    
    render() {
        let {data, phone, token,isLoggingout} = this.props;
        let {isSettingAccessible} = this.state;
		let {branchName, storeName, cashierName, appName} = this.props.settingData;
        let mcName = data.merchant && data.merchant.name ? data.merchant.name : appName;

        if(!token) return <Redirect to='/login'/>

        return (
            <React.Fragment>
            <div className="container mt-4 maxW-768">
                <div className="left-icons">
                    <Link to="/home"><img src="/cashier/shop/static/assets/images/icon-back.svg" width="28" alt=""/></Link>
                </div>
                
                <div className="page-title text-center">Thông tin cài đặt</div>
                
                
                <div className="media mt-5">
                    <img className="mr-3" src="/cashier/shop/static/assets/images/logo-mc-default.svg" width="64" alt="" />
                    <div className="media-body">
                        <div className="mc-name mt-2">{mcName}</div>
                        <span className="txtGray">{phone}</span>
                    </div>
                </div>
                
                <div className="mt-5 text-center">Chọn cửa hàng, quầy hàng nhận thông báo</div>
                
                <div className="row mt-5">
                    <div className="col-sm-6 mb-2">
                        <div className="form-group">
                            <label>Ứng dụng</label>
                            <div className="info-name mt-2">{appName}</div>
                        </div>
                    </div>
                    <div className="col-sm-6 mb-2">
                        <div className="form-group">
                            <label>Chi nhánh</label>
                            <div className="info-name mt-2">{branchName}</div>
                        </div>
                    </div>
                    
                    <div className="col-sm-6 mb-2">
                        <div className="form-group">
                            <label>Cửa hàng</label>
                            <div className="info-name mt-2">{storeName}</div>
                        </div>
                    </div>
                    <div className="col-sm-6 mb-2">
                        <div className="form-group">
                            <label>Quầy hàng</label>
                            <div className="info-name mt-2">{cashierName}</div>
                        </div>
                    </div>
                </div>
                
                <div className="row mt-5 justify-content-center">
                    {
                        isLoggingout ? <Loader/> :
                        <React.Fragment>
                        {
                            isSettingAccessible ?
                            <div className="col-sm-4">
                                <Link to="/passwordconfirm" className="btn btn-main w-100">THAY ĐỔI</Link>
                            </div> : null
                        }

                        <div className="col-sm-4">
                            <a href="javascript:;" className="btn btn-border w-100" onClick={this.handleLogout}>ĐĂNG XUẤT</a>
                        </div>
                        </React.Fragment>
                    }
                    
                </div>
            </div>
            
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
	return {
		settingData: state.settingData,
		phone: state.loginData.phone,
		token: state.loginData.token,
        data: state.loginData.result,
        logged: state.loginData.logged,
		isLoggingout: state.logoutData.isLoggingout,
		loggedout: state.logoutData.loggedout,
		loginType: state.loginData.loginType
	}
};

export default connect(mapStateToProps)(Information);